import { render, staticRenderFns } from "./Columnas.vue?vue&type=template&id=32df6a52&scoped=true&"
import script from "./Columnas.vue?vue&type=script&lang=js&"
export * from "./Columnas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df6a52",
  null
  
)

export default component.exports